import {IMuWidget} from "./IMuWidget";

export class ShowMore extends IMuWidget {
	public isSmall : boolean = false;
	beforeIndex(container: HTMLElement) {
		this.container.innerHTML = '<div mu-id="content" class="show-more--content">' + this.container.innerHTML
			+ '</div><div mu-id="expander" class="show-more--expander">Ukázat více</div>';
	}

	afterIndex() {
		this.expander_click();
	}

	expander_click() {
		this.isSmall = !this.isSmall;
		this.container.classList.toggle("show-more__small", this.isSmall);
	}
}